import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useCurrentCountry from './useCurrentCountry';
import { useCustomer } from './useCustomer';

type HookReturn = { initialValues: InitialValuesType };

export default function useContact(): HookReturn {
  const { t } = useTranslation();
  const { customer } = useCustomer();
  const { isUk } = useCurrentCountry();
  const [initialValues, setInitialValues] = useState<InitialValuesType>({
    ...defaultValues,
    country: isUk ? t('LABEL_UNITED_KINGDOM') : t('LABEL_FRANCE'),
  });

  useEffect(() => {
    if (customer?.isLoggedIn) {
      const {
        civilityNumber,
        firstName,
        lastName,
        addresses,
        phone,
        email,
        pcle,
      } = customer;
      setInitialValues({
        ...initialValues,
        civility: civilityNumber,
        firstName: firstName,
        lastName: lastName,
        email: email,
        nameWay: addresses?.P.street,
        nameComplement: addresses?.P.nameComplement || '',
        nameAddress: addresses?.P.nameAddress || '',
        locality: addresses?.P.saidPlace || '',
        postCode: addresses?.P.postalCode,
        city: addresses?.P.city,
        landLine: phone || '',
        customerNumber: pcle?.slice(0, -1) || '',
      });
    }
  }, [customer]);

  return {
    initialValues,
  };
}

const defaultValues = {
  turnstileToken: '',
  civility: '1',
  civilityNumber: '',
  lastName: '',
  firstName: '',
  email: '',
  nameWay: '',
  nameComplement: '',
  nameAddress: '',
  locality: '',
  postCode: '',
  city: '',
  country: '',
  landLine: '',
  customerNumber: '',
  orderNumber: '',
  subject: '',
  message: '',
};

type InitialValuesType = {
  turnstileToken: string;
  civility: string;
  civilityNumber: string;
  lastName: string;
  firstName: string;
  email: string;
  nameWay: string;
  nameComplement: string;
  nameAddress: string;
  locality: string;
  postCode: string;
  city: string;
  country: string;
  landLine: string;
  customerNumber: string;
  orderNumber: string;
  subject: string;
  message: string;
};
